<template>
  <div class="relative flex col-12">
    <div id="carousel" class="flex relative thin-scroll py1 col-12">
      <div
        class="
          mx-small
          p1
          flex flex-column
          items-center
          justify-center
          grey-bg
          border-black
          nowrap
          pointer
        "
        style="min-width: 12.5%"
        :class="{ 'purple-bg white': selected.includes(item.name) }"
        v-for="(item, index) in activities"
        :key="item"
        @click="select(item, index)"
      >
        <h5 class="col-12 h6n m0">{{ item.name }}</h5>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  props: {
    activities: {
      type: Array,
      default: [],
    },
  },
  setup() {
    const store = useStore();

    const selected = computed(() => store.state.selected || []);

    const select = (item, index) => {
      if (item.name) {
        if (selected.value.includes(item.name)) {
          if (selected.value.length > 1) {
            store.commit("removeSelected", item.name);
          }
        } else {
          store.commit("addSelected", item.name);
        }
      }
    };

    return {
      selected,
      select,
    };
  },
};
</script>

<style>
</style>